import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {searchStaff} from './actions';
import {bindActionCreators} from "redux";
import {Link} from 'react-router-dom';
import ListView from "../common/ListView";
import {Icon} from "antd";
import {getStaffRoles} from "../StaffRole/actions";

class StaffsPage extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    salonId: PropTypes.string.isRequired,
    search: PropTypes.object.isRequired,
    searchStaff: PropTypes.func.isRequired,
    getStaffRoles: PropTypes.func.isRequired,
    staffRoles: PropTypes.array.isRequired,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.salonId !== prevProps.salonId) this.load();
  }

  load = () => {
    const {salonId, getStaffRoles} = this.props;
    getStaffRoles({salonId});
  };

  render() {
    const {
      salonId, history, searchStaff, staffRoles,
      search: {searching, pagination, filters, sorter, results, searchFilter},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
      },
      {
        title: 'Available At All Salons',
        dataIndex: 'availableAtAllSalons',
        key: 'availableAtAllSalons',
        sorter: true,
        render: (value) => value ? "Yes" : "No",
      },
      {
        title: 'Role',
        dataIndex: 'role',
        key: 'staffRoleId',
        sorter: true,
        filters: staffRoles.map(({staffRoleId: value, name: text}) => ({value, text})),
      },
      {
        title: 'Active',
        dataIndex: 'active',
        key: 'active',
        sorter: true,
        render: active => <Icon type={active ? 'smile-o' : 'frown-o'}/>
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, {active, staffId}) => {
          const encodedId = encodeURIComponent(staffId);
          return (
            <React.Fragment>
              <Link to={`/staff/update/${encodedId}`}>Edit</Link>
              {active && [' | ', <Link key="fire" to={`/staff/fire/${encodedId}`}>Deactivate</Link>]}
            </React.Fragment>
          );
        }
      }
    ];
    return (
      <ListView
        title="Staff"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchStaff}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        salonId={salonId}
        rowKey="staffId"
        onAdd={() => history.push('/staff/add')}
      />
    );
  }
}

const mapStateToProps = state => ({
  loading: state.staff.staffsLoading,
  salonId: state.salon.selectedSalonId,
  search: state.staff.search,
  staffRoles: state.staffRole.staffRoles,
});

const mapDispatchToProps = dispatch => ({
  searchStaff: bindActionCreators(searchStaff, dispatch),
  getStaffRoles: bindActionCreators(getStaffRoles, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(StaffsPage);



// WEBPACK FOOTER //
// ./src/Staff/StaffsPage.js